// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Layout_pageWrapper__D7muT","contentContainer":"Layout_contentContainer__N1d8S"};